import React from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";
import styles from '../home/homepage.module.css'

import styles2 from './inside-look.module.css'
import Lazy from "../../common/lazy-scroll/Lazy";


const galleryImages = [
    {
        src: "/images/home/kidsplay.jpg",
        alt: "Enfants jouant ensemble dans la salle de jeux",
        caption: "Jeu en groupe",
    },
    {
        src: "/images/home/kidsread.jpg",
        alt: "Espace lecture avec des livres colorés",
        caption: "Moment lecture",
    },
    {
        src: "/images/home/kidscreative.jpg",
        alt: "Activité de peinture avec les enfants",
        caption: "Créativité en action",
    },
    {
        src: "/images/home/kidseating.jpg",
        alt: "Repas sain servi aux enfants",
        caption: "Pause déjeuner équilibrée",
    },
    {
        src: "/images/home/kidsplay.jpg",
        alt: "Espace extérieur avec toboggan",
        caption: "Jeux en plein air",
    },
    {
        src: "/images/home/kidsmusic.jpg",
        alt: "Activité d’éveil musical avec des instruments",
        caption: "Éveil musical",
    },
];

const InsideLook: React.FC = () => {
    return (
        <section className={styles2.section_container}>
            <MDBContainer>
                <h2 className={styles2.section_title}>
                    À l’intérieur de notre espace chaleureux et familial
                </h2>

                {/*<p className="text-center mb-4 px-3">*/}
                    <p className={styles.intro_paragraph}>
                        Découvrez quelques moments de vie quotidienne à la garderie :
                        jeux créatifs, éclats de rire et un environnement où chaque enfant se sent en sécurité,
                        épanoui et libre d'être lui-même.
                </p>

                <MDBRow>
                    {galleryImages.map((img, index) => (
                        <MDBCol
                            key={index}
                            xs="12"
                            sm="6"
                            md="4"
                            className="mb-4 d-flex justify-content-center"
                        >
                            <figure style={{
                                width: "100%",
                                maxWidth: "320px",
                                position: "relative",
                                margin: 0,
                                borderRadius: "12px",
                                overflow: "hidden"
                            }}>
                                {/*<img*/}
                                {/*    src={img.src}*/}
                                {/*    alt={img.alt}*/}
                                {/*    style={{*/}
                                {/*        width: "100%",*/}
                                {/*        height: "220px",*/}
                                {/*        objectFit: "cover",*/}
                                {/*        display: "block",*/}
                                {/*    }}*/}
                                {/*/>*/}
                                <Lazy SrcImage={img.src}
                                      className={styles.image}
                                      alt={img.alt}
                                />

                                <figcaption className={styles2.caption}
                                    style={{
                                        position: "absolute",
                                        bottom: 0,
                                        width: "100%",
                                        color: "white",
                                        padding: "8px 12px",
                                        fontSize: "1rem",
                                        textAlign: "center",
                                        boxSizing: "border-box",
                                        borderBottomLeftRadius: "12px",
                                        borderBottomRightRadius: "12px",
                                    }}
                                >
                                    {img.caption}
                                </figcaption>
                            </figure>
                        </MDBCol>
                    ))}
                </MDBRow>
            </MDBContainer>
        </section>
    );
};

export default InsideLook;
